export default [
    {
        path: '/welcome',

        name: 'Welcome',

        component: () => import('@/views/welcome'),
    },
];